import { createAppAsyncThunk } from '../appAsyncThunk';
import { resetWorkspaceState } from '../workspace/slice';
import { history } from '../../router/BrowserRouter';
import { setIsLoggedIn } from './slice';
import { SignIn } from './types';
import {
    signIn,
    signOut,
    getCurrentUser,
} from 'aws-amplify/auth';

export const signInThunk = createAppAsyncThunk(
    'auth/signInThunk', async ({ username, password, from }: SignIn, { dispatch, rejectWithValue }) => {
        try {
            const response = await signIn({ username, password });

            if (response.isSignedIn) {
                localStorage.setItem('auth_status', 'Authenticated');
                dispatch(setIsLoggedIn(true));
                history.push(from || '/workspace');
                return from;
            } else {
                return rejectWithValue('Incorrect username or password');
            }
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            } else {
                return rejectWithValue('An error occurred, Try again later');
            }
        }
    });

export const getUserInfoThunk = createAppAsyncThunk(
    'auth/getUserInfoThunk', async () => {
        const { userId } = await getCurrentUser();
        return userId;
    });

export const signOutThunk = createAppAsyncThunk(
    'auth/signOutThunk', async (_, { dispatch }) => {
        const response = await signOut();
        dispatch(resetWorkspaceState());
        return response;
    });